import { supabase } from './supabase'

// Sub-sprint A · Parte 1 — data de la vista Suscriptores v2.
// Llama al RPC admin_suscriptores_v2 (SECURITY DEFINER, gate is_admin).
// Devuelve { kpis, titulares } — KPIs de negocio (no-test) + filas agrupadas por titular.
export async function getSuscriptoresV2() {
  const { data, error } = await supabase.rpc('admin_suscriptores_v2')
  if (error) throw error
  return data || { kpis: {}, titulares: [] }
}
